import { render } from "./center-offers-banner.vue?vue&type=template&id=be23fb4e&scoped=true"
import script from "./center-offers-banner.vue?vue&type=script&lang=js"
export * from "./center-offers-banner.vue?vue&type=script&lang=js"

import "./center-offers-banner.vue?vue&type=style&index=0&id=be23fb4e&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be23fb4e"]])

export default __exports__